// Weckauftrag fuer die eigene App nach dem Cast-Standby-Neustart (nur Samsung Tizen).
//
// Anlass (U800F, Tizen 9, 21.10.2026): nach rebootDevice im Standby startet die
// Firmware die tizenStartapp nur MANCHMAL wieder. Kam sie hoch, war sie beim
// Einschalten vorn (20.10.); kam sie nicht hoch, stellte die Firmware beim
// Einschalten die zuletzt sichtbare App wieder her (YouTube des Casts) und
// erst HOME holte die Hotel-App. Laeuft die App nach dem Neustart nicht, kann
// sie selbst nichts mehr tun - also bestellt sie ihren Start VOR dem Neustart.
//
// Weg: tizen.alarm.add(AlarmRelative, eigene App-Id). Das Privileg alarm hat
// die 6.5er-WGT. Der Auftrag wird unmittelbar vor rebootDevice gesetzt - die
// konfigurierbare Wartezeit bis zum Neustart (CAST_STANDBY_REBOOT_MIN) spielt
// deshalb keine Rolle, gezaehlt wird ab dem Neustart.
//
// Gemessen am U800F (21.10.2026): der Alarm ueberlebt den Neustart, ein
// Auftrag ueber 150 s startete die App 155 s nach rebootDevice. Zu spaet -
// wer dazwischen einschaltet, sieht YouTube. Wie frueh das System nach dem
// Hochfahren einen Alarm ausfuehren kann, ist nicht bekannt; ein zu frueher
// koennte ins Hochfahren fallen und verloren gehen. Deshalb mehrere
// gestaffelte Auftraege (WAKE_AFTER_S): der erste, der greift, startet die
// App - und dieser Start loescht die uebrigen (clear beim App-Start).
// 45/75/110/150 s: der 45-s-Auftrag griff zweimal (App 50-51 s nach dem
// Reboot am Socket). Jetzt ab 30 s alle 20 s, um das Fenster zu verkleinern.
// Der Abstand muss groesser bleiben als die Zeit vom Alarm bis zum clear -
// ein weiterer launch startet die laufende App sonst noch einmal neu. clear
// laeuft deshalb ganz am Anfang von main.js.
//
// Jeder App-Start loescht die eigenen Auftraege (clear): kam die App von
// selbst hoch, fallen sie aus; scheitert der Neustart, nimmt die
// Rollback-Kette sie ebenfalls zurueck.

const WAKE_AFTER_S = [30, 50, 70, 90, 110, 130, 150];

function alarmApi() {
  try {
    const t = window.tizen;
    return t && t.alarm && typeof t.alarm.add === 'function' && typeof t.AlarmRelative === 'function' ? t : null;
  } catch (e) {
    return null;
  }
}

function ownAppId() {
  try {
    return window.tizen.application.getCurrentApplication().appInfo.id;
  } catch (e) {
    return null;
  }
}

const WakeAlarm = {
  // Start der eigenen App nach WAKE_AFTER_S Sekunden bestellen. true = mindestens einer gesetzt.
  set(why) {
    const t = alarmApi();
    const id = ownAppId();
    if (!t || !id) {
      console.log('[WakeAlarm] nicht verfuegbar - kein Weckauftrag');
      return false;
    }
    const set = [];
    WAKE_AFTER_S.forEach((sec) => {
      try {
        t.alarm.add(new t.AlarmRelative(sec), id);
        set.push(sec);
      } catch (e) {
        console.log('[WakeAlarm] Weckauftrag ' + sec + ' s fehlgeschlagen: ' + ((e && (e.name || e.message)) || e));
      }
    });
    if (set.length) console.log('[WakeAlarm] Weckauftraege gesetzt: ' + id + ' in ' + set.join(' / ') + ' s (' + why + ')');
    return set.length > 0;
  },
  // Alle eigenen Auftraege loeschen. Beim App-Start und beim Rollback.
  clear(why) {
    const t = alarmApi();
    if (!t) return;
    try {
      const pending = typeof t.alarm.getAll === 'function' ? t.alarm.getAll() : [];
      if (!pending || !pending.length) return;
      t.alarm.removeAll();
      console.log('[WakeAlarm] ' + pending.length + ' Weckauftrag/-auftraege geloescht (' + why + ')');
    } catch (e) {
      console.log('[WakeAlarm] Loeschen fehlgeschlagen: ' + ((e && (e.name || e.message)) || e));
    }
  },
};

export default WakeAlarm;



// WEBPACK FOOTER //
// ./src/helpers/WakeAlarm.js